/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/document';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveDocumentRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.corporate_card.resources.Document.Type",
                    "id": 2,
                    "rule": "required"
                  }
                }
              },
              "RetrieveDocumentResponse": {
                "fields": {
                  "document": {
                    "type": ".squareup.corporate_card.resources.Document",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveDocumentRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveDocumentResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveDocumentRequest @ squareup/corporate_card/service/retrieve_document.proto at 9:1
 */
export const RetrieveDocumentRequest = $root.lookupType('squareup.corporate_card.service.RetrieveDocumentRequest');
fixType(RetrieveDocumentRequest);
Builder.createAndAttachToType(RetrieveDocumentRequest);
/**
 * SOURCE RetrieveDocumentResponse @ squareup/corporate_card/service/retrieve_document.proto at 21:1
 */
export const RetrieveDocumentResponse = $root.lookupType('squareup.corporate_card.service.RetrieveDocumentResponse');
fixType(RetrieveDocumentResponse);
Builder.createAndAttachToType(RetrieveDocumentResponse);